import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { stripHtmlAndTruncate } from "../../../../utils/Actions/stripHtmlAndTruncate";
import { getBaseDomainFromUrl } from "../../../../utils/Actions/getBaseDomainFromUrl";
import { S3URL } from "../../../../data/globalConstants";

export default function MediaGridItem({ index, mediaSection, item }) {
  const { genreSlug, showSlug } = useParams();

  const [mediaUrl, setMediaUrl] = useState(null);
  const [mediaThumbnail, setMediaThumbnail] = useState(null);
  const [mediaDescription, setMediaDescription] = useState("");
  const [imgOrientation, setImgOrientation] = useState("landscape");

  useEffect(() => {
    // console.log("media", item.title, item);
    const hasValidUrl =
      typeof item.url === "string" &&
      item.url.trim() !== "" &&
      item.url.includes("http");

    if (hasValidUrl) {
      setMediaUrl(item.url);
    } else {
      setMediaUrl(
        "/" + genreSlug + "/" + showSlug + "/" + mediaSection + "/" + item.slug,
      );
    }

    setMediaDescription(stripHtmlAndTruncate(item.description, 100));

    const hasValidThumbnail =
      typeof item.thumbnail === "string" && item.thumbnail.trim() !== "";
    if (hasValidThumbnail) {
      setMediaThumbnail(S3URL + item.thumbnail);
    } else if (item.type === "youtube") {
      setMediaThumbnail(
        `https://i.ytimg.com/vi/${item.filename}/maxresdefault.jpg`,
      );
    } else if (
      mediaSection === "press" ||
      mediaSection === "design-presentations" ||
      mediaSection === "publications"
    ) {
      setMediaThumbnail(S3URL + item.filename);
    } else if (mediaSection === "script") {
      setMediaThumbnail("/img/media-thumb-script-placeholder.png");
    } else {
      setMediaThumbnail("/img/media-thumb-placeholder-landscape.jpg");
    }
  }, [item]);

  const getImageOrientation = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const w = img.naturalWidth,
          h = img.naturalHeight;
        resolve(w > h ? "landscape" : w < h ? "portrait" : "square");
      };
      img.onerror = () => reject(new Error("Failed to load image"));
      img.src = url;
    });

  useEffect(() => {
    if (!mediaThumbnail) return;

    const loadOrientation = async () => {
      try {
        const orientation = await getImageOrientation(mediaThumbnail);
        setImgOrientation(orientation);
      } catch (error) {
        console.error("Failed to determine image orientation:", error);
        setImgOrientation("landscape");
      }
    };
    loadOrientation();
  }, [mediaThumbnail]);

  return (
    <Link
      to={mediaUrl}
      target={mediaSection === "press" ? "_blank" : "_self"}
      className="show-page-section-item"
    >
      <div className="show-page-section-item-thumb-container">
        <div
          className="show-page-section-item-thumb"
          style={{
            backgroundImage: mediaThumbnail
              ? `url("${mediaThumbnail}")`
              : "none",
            backgroundSize:
              imgOrientation === "landscape" ? "cover" : "contain",
            backgroundColor:
              mediaSection === "press" ? "rgba(0,0,0,.5)" : "transparent",
          }}
        >
          <img src="/img/media-thumb-placeholder-landscape.jpg" alt="NF" />
        </div>
      </div>
      <div className="show-page-section-item-meta">
        <div className="show-page-section-item-title">
          {/*{index <= 1 ? <span className={"new-indicator"}>NEW</span> : <></>}*/}
          {mediaSection === "press" && item.url ? (
            <span className={"show-page-section-item-url"}>
              {getBaseDomainFromUrl(item.url) + " - "}
            </span>
          ) : null}
          {item.title}
        </div>
        <div className="show-page-section-item-description">
          {mediaDescription}
        </div>
      </div>
    </Link>
  );
}
